import { render, staticRenderFns } from "./NavListItem.vue?vue&type=template&id=a89d8826"
import script from "./NavListItem.vue?vue&type=script&lang=js"
export * from "./NavListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports